export const HOME_PAGE = '/'
export const ABOUTUS_PAGE = '/about-us'
export const CONTACT_PAGE = '/contact'
export const PRODUCTS_PAGE = '/products'
export const REQUEST_PAGE = '/request-demo'
export const LEGAL_PAGE = '/legal'
export const SUPPORT_PAGE = '/support'
export const SUPPORT_PRODUCT_PAGE = '/support/ticket'
export const PRODUCT_TOPIC_PAGE = '/support/topics'

// Trip Pages
export const TRIP_SUITE_HOMEPAGE = '/transport-suite'
export const TRIP_PRICING_PAGE = '/transport-suite/pricing'

// Reception Suite Pages

// Reception Suite
export const RECEPTION_SUITE_PAGE = '/products/reception-suite'
export const RECEPTION_PRICING_PAGE = '/products/reception-suite/pricing'

// Front Desk  Pages
export const FRONT_DESK= '/frontdesk'